export type ReportType = "reviewReport" | "employeeReport" | "goalReport" | "surveyReport";
export type ReportsType = "reviewReports" | "employeeReports" | "goalReports" | "surveyReports";
export type ReportCSVType = "reviewReportsCSV" | "employeeReportsCSV" | "goalReportsCSV" | "surveyReportsCSV";
export type ReportSortType = "ReviewReportsSort" | "EmployeeReportsSort" | "GoalReportsSort" | "SurveyReportsSort";
export type ReportSummarizeByType =
	| "ReviewReportsSummarizeBy"
	| "EmployeeReportsSummarizeBy"
	| "GoalReportsSummarizeBy"
	| "SurveyReportsSummarizeBy";
export type ReportAggOperationsType =
	| "ReviewReportsAggregationOperation"
	| "EmployeeReportsAggregationOperation"
	| "GoalReportsAggregationOperation"
	| "SurveyReportsAggregationOperation";

export const REPORT_CONFIG: Record<
	ReportType,
	{
		queryName: string;
		reportsType: ReportsType;
		reportCSVType: ReportCSVType;
		sorts: ReportSortType;
		summarizeBy: ReportSummarizeByType;
		aggregationOperations: ReportAggOperationsType;
	}
> = {
	reviewReport: {
		queryName: "GetReviewReportData",
		reportsType: "reviewReports",
		reportCSVType: "reviewReportsCSV",
		sorts: "ReviewReportsSort",
		summarizeBy: "ReviewReportsSummarizeBy",
		aggregationOperations: "ReviewReportsAggregationOperation",
	},
	employeeReport: {
		queryName: "GetEmployeeReportData",
		reportsType: "employeeReports",
		reportCSVType: "employeeReportsCSV",
		sorts: "EmployeeReportsSort",
		summarizeBy: "EmployeeReportsSummarizeBy",
		aggregationOperations: "EmployeeReportsAggregationOperation",
	},
	goalReport: {
		queryName: "GetGoalReportData",
		reportsType: "goalReports",
		reportCSVType: "goalReportsCSV",
		sorts: "GoalReportsSort",
		summarizeBy: "GoalReportsSummarizeBy",
		aggregationOperations: "GoalReportsAggregationOperation",
	},
	surveyReport: {
		queryName: "GetSurveyReportData",
		reportsType: "surveyReports",
		reportCSVType: "surveyReportsCSV",
		sorts: "SurveyReportsSort",
		summarizeBy: "SurveyReportsSummarizeBy",
		aggregationOperations: "SurveyReportsAggregationOperation",
	},
};
